import { Skeleton, Stack } from "@mui/material";
import { MAX_WIDTH_OBJ } from '../../../../config/cacheKey';

const ApplyRequestStepsSkeleton = () => {

    return (
        <>
            <Stack spacing={1}>
                {/* For variant="text", adjust the height via font-size */}
                <Skeleton variant="rectangular" style={{ margin: "auto " }} width={MAX_WIDTH_OBJ} height={80} />
                <Skeleton variant="rectangular" style={{ margin: "auto ", marginTop: "10px" }} width={MAX_WIDTH_OBJ} height={80} />
                <Skeleton variant="rectangular" style={{ margin: "auto ", marginTop: "10px" }} width={MAX_WIDTH_OBJ} height={80} />
                <Skeleton variant="rectangular" style={{ margin: "auto ", marginTop: "10px" }} width={MAX_WIDTH_OBJ} height={80} />
                <Skeleton variant="rectangular" style={{ margin: "auto ", marginTop: "10px" }} width={MAX_WIDTH_OBJ} height={80} />
                <Skeleton variant="rectangular" style={{ margin: "auto ", marginTop: "10px" }} width={MAX_WIDTH_OBJ} height={40} />

            </Stack></>
    )
}

export default ApplyRequestStepsSkeleton;